import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
//import { actionAuth } from "../slices/AuthSlice";
//import Swal from "sweetalert2";

export const DataApi = createApi({
  reducerPath: "DataApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_HOST,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;

      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["companies", "alerts", "notification", "favourite"],
  endpoints: (builder) => ({
    addBookmark: builder.mutation({
      query: (job_id) => ({
        url: "candidate/bookmarkjob",
        method: "POST",
        body: { job_id },
      }),
    }),
    getBookmark: builder.mutation({
      query: (data) => ({
        url: "candidate/bookmark/listing",
        method: "POST",
        body: data,
      }),
    }),
    addBookmarkEvent: builder.mutation({
      query: (event_id) => ({
        url: "candidate/event/bookmarks",
        method: "POST",
        body: { event_id },
      }),
    }),
    getBookmarkEvent: builder.mutation({
      query: () => ({
        url: "candidate/event/bookmarks",
        method: "GET",
      }),
    }),
    applyJob: builder.mutation({
      query: (job_id) => ({
        url: "candidate/jobapply",
        method: "POST",
        body: { job_id },
      }),
    }),
    getApplyJob: builder.mutation({
      query: (data) => ({
        url: "candidate/appliedjob/listing",
        method: "POST",
        body: data,
      }),
    }),
    getJobAlert: builder.query({
      query: (data) => ({
        url: "candidate/alertjob/listing",
        method: "POST",
        body: data,
      }),
      providesTags: ["alerts"],
    }),
    getEvents: builder.mutation({
      query: (data) => ({
        url: "candidate/appliedevents/listing",
        method: "POST",
        body: data,
      }),
    }),
    applyEvents: builder.mutation({
      query: (event_id) => ({
        url: "candidate/applytoevents",
        method: "POST",
        body: { event_id },
      }),
    }),
    addFavoriteCompany: builder.mutation({
      query: (recruiter_id) => ({
        url: "candidate/company/favorate",
        method: "POST",
        body: { recruiter_id },
      }),
      invalidatesTags: ["favourite"],
    }),
    getFavoriteCompany: builder.query({
      query: () => ({
        url: "candidate/company/favorate/listing",
        method: "POST",
      }),
      providesTags: ["companies"],
    }),
    unFavoriteCompany: builder.mutation({
      query: (company_id) => ({
        url: "candidate/company/unfavorate",
        method: "POST",
        body: { company_id },
      }),
      invalidatesTags: ["companies"],
    }),
    addAlert: builder.mutation({
      query: (data) => ({
        url: "candidate/jobalertset",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["alerts"],
    }),
    removeAlert: builder.mutation({
      query: (alert_id) => ({
        url: "candidate/removealert",
        method: "POST",
        body: { alert_id },
      }),
      invalidatesTags: ["alerts"],
    }),
    getNotification: builder.mutation({
      query: (data) => ({
        url: "notification/get-notifications",
        method: "POST",
        body: data,
      }),
      providesTags: ["notification"],
    }),
    readAllNotifications: builder.mutation({
      query: (data) => ({
        url: "notification/update-all-read-by",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["notification"],
    }),
  }),
});

export const {
  useAddBookmarkMutation,
  useGetBookmarkMutation,
  useApplyJobMutation,
  useGetApplyJobMutation,
  useGetJobAlertQuery,
  useGetEventsMutation,
  useAddFavoriteCompanyMutation,
  useGetFavoriteCompanyQuery,
  useApplyEventsMutation,
  useUnFavoriteCompanyMutation,
  useAddAlertMutation,
  useRemoveAlertMutation,
  useGetNotificationMutation,
  useReadAllNotificationsMutation,
  useGetBookmarkEventMutation,
  useAddBookmarkEventMutation,
} = DataApi;
